import { render, staticRenderFns } from "./ModalComposant.vue?vue&type=template&id=d5ab0ed6&"
import script from "./ModalComposant.vue?vue&type=script&lang=js&"
export * from "./ModalComposant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports